export const PAYMENT_TIME_ZONE = "America/Los_Angeles";

export const statusMeta = {
  paid: { label: "Paid", tone: "success", explanation: "Payment confirmed and enrollment activated." },
  partially_refunded: { label: "Partially refunded", tone: "warning", explanation: "Part of this payment has been returned." },
  refunded: { label: "Refunded", tone: "danger", explanation: "This payment has been returned." },
  payment_pending: { label: "Action needed", tone: "warning", explanation: "Checkout is ready, but payment has not been confirmed." },
  pending: { label: "Processing", tone: "warning", explanation: "We are preparing this checkout." },
  failed: { label: "Payment failed", tone: "danger", explanation: "The processor could not complete this payment." },
  cancelled: { label: "Cancelled", tone: "neutral", explanation: "Checkout ended before payment was confirmed." },
};

export function formatMoney(amountCents = 0, currency = "usd") {
  try { return new Intl.NumberFormat(undefined, { style: "currency", currency: String(currency).toUpperCase() }).format(amountCents / 100); }
  catch { return `${(amountCents / 100).toFixed(2)} ${String(currency).toUpperCase()}`; }
}

export function formatPaymentDate(value, includeTime = false) {
  if (!value) return "Not recorded";
  return `${new Intl.DateTimeFormat(undefined, { timeZone: PAYMENT_TIME_ZONE, month: "short", day: "numeric", year: "numeric", ...(includeTime ? { hour: "numeric", minute: "2-digit" } : {}) }).format(new Date(value))} PT`;
}

export function paymentError(error, fallback) {
  const value = error?.response?.data?.error;
  return (typeof value === "string" ? value : value?.message) || error?.message || fallback;
}

export const playerName = (row) => `${row.player?.firstName || ""} ${row.player?.lastName || ""}`.trim() || "Player unavailable";
